import { Box, TextField } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const CellStatus = (params: any) => {

    const { t } = useTranslation('booking');

    const value = useMemo<string>(() => {

        const status = t(`status.${params.data.status}`)
        const substatus = t(`substatus.${params.data.subStatus}`)

        return params.data.subStatus ? `${status} - ${substatus}` : `${status}`
    }, [params.data]);

    return (
        <Box width="100%">
            <TextField
                name="RaStatus-SubStatus"
                value={value}
            />
        </Box>
    );
};

export default CellStatus;
